import { Card, CardContent } from '@/components/card/card'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/dialog/dialog'
import { Tabs, TabsList, TabsTrigger } from '@/components/tabs/tabs'

import { cn } from '@/lib/utils'

import { SubscriptionOverlay } from '../../../subscription-overlay/subscription-overlay'
import { useProcessingTimeTrendDialog } from '../hooks/use-processing-time-trend-dialog'
import { TIMEFRAME_OPTIONS } from './constants'
import { InquiryDateTrendChart } from './inquiry-date-trend-chart'
import { mockMonthlySeriesInquiryDate, mockMonthlySeriesProcessingTime } from './mock'
import { ProcessingTimeTrendChart } from './processing-time-trend-chart'

export const ProcessingTimeTrendDialog = () => {
  const {
    dataUser,
    applicationFilingDate,
    monthlySeriesProcessingTime,
    monthlySeriesInquiryDate,
    timeFrameProcessingTime,
    timeFrameInquiryDate,
    isDialogOpen,
    handleChangeDialogOpen,
    handleTimeFrameProcessingTimeChange,
    handleTimeFrameInquiryDateChange,
  } = useProcessingTimeTrendDialog()

  return (
    <Dialog open={isDialogOpen} onOpenChange={handleChangeDialogOpen}>
      <DialogContent className={cn('max-w-[770px]', 'overflow-scroll', 'bg-zinc-50')}>
        <div className={cn('relative', 'overflow-visible')}>
          <DialogHeader>
            <DialogTitle>Processing Times Trends</DialogTitle>
            <DialogDescription className={cn('sr-only')}>
              Interactive chart displaying USCIS processing trends over time. Processing times are shown in months, with
              data points plotted monthly
            </DialogDescription>
          </DialogHeader>

          <div className={cn('relative', 'mt-4', 'pt-4')}>
            <h3 className={cn('mb-3', 'text-lg font-semibold')}>USCIS Processing Times Trends</h3>
            <div className={cn('mb-5', 'space-y-4')}>
              <Tabs value={timeFrameProcessingTime} onValueChange={handleTimeFrameProcessingTimeChange}>
                <TabsList>
                  {TIMEFRAME_OPTIONS.map(({ value, label }) => {
                    return (
                      <TabsTrigger key={value} value={String(value)}>
                        {label}
                      </TabsTrigger>
                    )
                  })}
                </TabsList>
              </Tabs>

              <Card>
                <CardContent className="pb-9 pl-9 pr-0 pt-6">
                  {monthlySeriesProcessingTime && (
                    <ProcessingTimeTrendChart
                      monthlySeries={
                        dataUser?.hasSubscription ? monthlySeriesProcessingTime : mockMonthlySeriesProcessingTime
                      }
                    />
                  )}
                </CardContent>
              </Card>
            </div>

            <h3 className={cn('mb-3', 'text-lg font-semibold')}>Inquiry Date Trends</h3>
            <div className={cn('space-y-4')}>
              <Tabs value={timeFrameInquiryDate} onValueChange={handleTimeFrameInquiryDateChange}>
                <TabsList>
                  {TIMEFRAME_OPTIONS.map(({ value, label }) => {
                    return (
                      <TabsTrigger key={value} value={String(value)}>
                        {label}
                      </TabsTrigger>
                    )
                  })}
                </TabsList>
              </Tabs>

              <Card>
                <CardContent className="pb-9 pl-9 pr-0 pt-6">
                  {monthlySeriesInquiryDate && (
                    <InquiryDateTrendChart
                      monthlySeries={
                        dataUser?.hasSubscription ? monthlySeriesInquiryDate : mockMonthlySeriesInquiryDate
                      }
                      applicationFilingDate={dataUser?.hasSubscription ? applicationFilingDate : '2024-01-01'}
                    />
                  )}
                </CardContent>
              </Card>
            </div>

            {!dataUser?.hasSubscription && (
              <SubscriptionOverlay isAdmin={dataUser?.isAdmin} isFreeTrialAvailable={dataUser?.isFreeTrialAvailable} />
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
